import { useEffect } from 'react'
import { Link } from 'react-router-dom'

import hero1Url from '../../assets/landing/a0fecf6f-7f67-420d-87cb-087044bbfedb.jpg'
import hero2Url from '../../assets/landing/ebee4037-f441-4cd6-821f-3efdbe8849cb.jpg'
import hero3Url from '../../assets/landing/4be470a4-6862-4786-a99c-9d14f30687d9.jpg'
import hero4Url from '../../assets/landing/34c7f6f0-eeb7-4a35-bc6a-6593b04e9599.jpg'
import showcaseUrl from '../../assets/landing/92bd0ffc-79d9-4724-bb43-d4dbcbdcc5ba.jpg'

export default function Landing() {
  useEffect(() => {
    const nav = document.getElementById('publicLandingNav')
    if (!nav) return

    const onScroll = () => {
      nav.classList.toggle('scrolled', window.scrollY > 8)
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    onScroll()
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => {
    const els = Array.from(document.querySelectorAll('.public-landing .reveal'))
    if (els.length === 0) return
    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-in'))
      return
    }

    const io = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in')
            io.unobserve(e.target)
          }
        }
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' },
    )

    els.forEach((el) => io.observe(el))
    return () => io.disconnect()
  }, [])

  return (
    <div className="public-landing page">
      <nav className="nav" id="publicLandingNav">
        <div className="nav-inner">
          <a href="#top" className="brand">
            <span className="dot" />
            <span>Liste de naissance</span>
          </a>
          <div className="nav-links">
            <a href="#fonctionne">Comment ça marche</a>
            <a href="#exemple">Exemple</a>
            <a href="#temoignages">Témoignages</a>
            <a href="#faq">Questions</a>
          </div>
          <Link className="nav-cta" to="/me/new">
            Créer ma liste
          </Link>
        </div>
      </nav>

      <main>
        <header className="hero" id="top">
          <div className="wrap">
            <div className="hero-stripe" aria-hidden="true">
              <span>·</span>
              <span>·</span>
              <span>·</span>
            </div>
            <p className="eyebrow">Pour accueillir bébé, ensemble</p>
            <h1 className="display">
              Une liste qui vous <em>ressemble</em>.
            </h1>
            <p className="hero-lede">
              Une liste de naissance élégante, sans publicité, sans intermédiaire&nbsp;: vos invités
              participent comme ils le souhaitent — un montant, ou un objet entier. Vous, vous
              décidez.
            </p>
            <div className="cta-row">
              <Link to="/me/new" className="btn-primary" id="ctaTop">
                Créer ma liste{' '}
                <span className="arrow" aria-hidden="true">
                  →
                </span>
              </Link>
              <a href="#exemple" className="btn-ghost">
                Voir un exemple
              </a>
            </div>
            <div className="hero-meta">
              <span>
                <span className="check">✓</span> Sans commission
              </span>
              <span>
                <span className="check">✓</span> Sans publicité
              </span>
              <span>
                <span className="check">✓</span> Prête en 5&nbsp;minutes
              </span>
            </div>

            <div className="hero-preview reveal">
              <div className="preview-frame" aria-hidden="true">
                <div className="preview-bar">
                  <i />
                  <i />
                  <i />
                </div>
                <div className="preview-content">
                  <div className="preview-head">
                    <p className="eyebrow" style={{ marginBottom: 6 }}>
                      Liste de naissance
                    </p>
                    <p className="h2">
                      <em>Bébé Lou</em>
                    </p>
                    <p className="date-mini">
                      <em>Naissance prévue le</em> 12 mars 2027
                    </p>
                  </div>
                  <div className="preview-grid">
                    <div className="pcard">
                      <div className="pcard-img">
                        <img src={hero1Url} alt="" />
                      </div>
                      <p className="pcard-title">Poussette Yoyo</p>
                      <div className="pcard-prog">
                        <i style={{ width: '71%' }} />
                      </div>
                      <p className="pcard-meta">320 € sur 450 €</p>
                    </div>
                    <div className="pcard">
                      <div className="pcard-img">
                        <img src={hero2Url} alt="" />
                      </div>
                      <p className="pcard-title">Écharpe de portage</p>
                      <div className="pcard-prog">
                        <i style={{ width: '100%' }} />
                      </div>
                      <p className="pcard-meta">Entièrement offert ❤</p>
                    </div>
                    <div className="pcard">
                      <div className="pcard-img">
                        <img src={hero3Url} alt="" />
                      </div>
                      <p className="pcard-title">Doudou en lin</p>
                      <div className="pcard-prog">
                        <i style={{ width: '0%' }} />
                      </div>
                      <p className="pcard-meta">À offrir</p>
                    </div>
                    <div className="pcard">
                      <div className="pcard-img">
                        <img src={hero4Url} alt="" />
                      </div>
                      <p className="pcard-title">Mobile en bois</p>
                      <div className="pcard-prog">
                        <i style={{ width: '42%' }} />
                      </div>
                      <p className="pcard-meta">40 € sur 95 €</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>

        <section className="values" id="pourquoi">
          <div className="wrap">
            <p className="eyebrow section-eyebrow">Pourquoi cette liste</p>
            <h2 className="section-title reveal">
              Pensée pour les <em>jeunes parents</em>, pas pour les marques.
            </h2>
            <p className="section-lede reveal">
              Pas d&apos;algorithme, pas de pub, pas de commission. Juste une page sobre,
              personnalisée, que vos proches consultent sans friction.
            </p>
            <div className="values-grid">
              <div className="value reveal">
                <span className="num">i.</span>
                <h3>Élégante par défaut</h3>
                <p>
                  Une mise en page éditoriale, des typographies choisies, une ambiance douce. Pas de
                  bandeau publicitaire ni de logo affilié.
                </p>
              </div>
              <div className="value reveal">
                <span className="num">ii.</span>
                <h3>Vraiment vous</h3>
                <p>
                  Tous les objets sont les vôtres. Vous décrivez, vous fixez le prix, vous ajoutez
                  le lien si vous le souhaitez. Aucune sélection imposée.
                </p>
              </div>
              <div className="value reveal">
                <span className="num">iii.</span>
                <h3>Sans intermédiaire</h3>
                <p>
                  Vos invités versent directement sur votre IBAN, Lydia, Wero ou PayPal. Pas de
                  cagnotte gelée, pas de frais, pas d&apos;attente.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="fonctionne">
          <div className="wrap">
            <p className="eyebrow section-eyebrow">En trois temps</p>
            <h2 className="section-title reveal">
              Comment ça <em>marche</em>.
            </h2>
            <p className="section-lede reveal">
              Il vous faut une dizaine de minutes pour mettre votre liste en ligne — et un café.
            </p>
            <div className="steps">
              <div className="step reveal">
                <span className="step-num">01</span>
                <h3>Créez votre page</h3>
                <p>
                  Un titre, une date, un mot d&apos;accueil. Une photo, peut-être. C&apos;est déjà
                  très joli.
                </p>
              </div>
              <div className="step reveal">
                <span className="step-num">02</span>
                <h3>Ajoutez vos envies</h3>
                <p>
                  Poussette, doudou, livres, séances photo… avec un prix et — si vous voulez — un
                  lien. Vous gardez la main sur tout.
                </p>
              </div>
              <div className="step reveal">
                <span className="step-num">03</span>
                <h3>Partagez le lien</h3>
                <p>
                  Vos proches participent comme ils le souhaitent — un montant ou l&apos;objet
                  entier. Vous recevez tout, directement.
                </p>
              </div>
            </div>
            <div className="ornament" style={{ marginTop: 64 }}>
              <span className="dot" />
              <span className="line" />
              <span className="dot" />
            </div>
          </div>
        </section>

        <section className="showcase" id="exemple">
          <div className="wrap">
            <div className="showcase-grid">
              <div className="showcase-text reveal">
                <p className="eyebrow">Une page comme un faire-part</p>
                <h2 className="section-title">
                  Sobre, <em>personnelle</em>, vivante.
                </h2>
                <p>
                  Chaque liste est une page web à votre image, hébergée à une adresse simple et
                  privée que vous partagez à qui vous voulez. Vos invités voient ce qui a déjà été
                  offert — et ce qu&apos;il reste à offrir, sans avoir à demander.
                </p>
                <ul className="feat-list">
                  <li>
                    <span className="pip" /> Photos en grand format, descriptions soignées
                  </li>
                  <li>
                    <span className="pip" /> Barres de progression discrètes, jamais une pression
                  </li>
                  <li>
                    <span className="pip" /> IBAN, Lydia, Wero, PayPal — vos invités choisissent
                  </li>
                  <li>
                    <span className="pip" /> Page protégée par un lien privé, sans inscription
                  </li>
                  <li>
                    <span className="pip" /> Petits mots laissés par vos proches, gardés pour plus
                    tard
                  </li>
                </ul>
              </div>
              <div className="reveal">
                <div className="showcase-img">
                  <img src={showcaseUrl} alt="Vue d'une liste de naissance" />
                  <div className="badge">
                    <em>Bébé Lou</em> · Naissance le 12 mars 2027
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="temoignages">
          <div className="wrap">
            <p className="eyebrow section-eyebrow">Des familles l&apos;ont déjà essayée</p>
            <h2 className="section-title reveal">
              Ce qu&apos;on en <em>dit</em>.
            </h2>
            <div className="testis-grid">
              <article className="testi reveal">
                <span className="qmark" aria-hidden="true">
                  &quot;
                </span>
                <blockquote>
                  On voulait quelque chose de <em>doux</em>, pas une liste de courses. Nos amis ont
                  adoré l&apos;esprit, et on a tout reçu sans avoir à expliquer comment ça marche.
                </blockquote>
                <div className="who">
                  <div className="ava">A</div>
                  <div>
                    <div className="who-name">Alice &amp; Raphaël</div>
                    <div className="who-meta">Paris · Bébé Gomez</div>
                  </div>
                </div>
              </article>
              <article className="testi reveal">
                <span className="qmark" aria-hidden="true">
                  &quot;
                </span>
                <blockquote>
                  La page met tout le monde à l&apos;aise. Mes parents ont participé à l&apos;IBAN,
                  mes copines ont acheté le doudou — chacun à <em>sa manière</em>.
                </blockquote>
                <div className="who">
                  <div className="ava">C</div>
                  <div>
                    <div className="who-name">Camille</div>
                    <div className="who-meta">Lyon · Bébé Marin</div>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </section>

        <section className="faq" id="faq">
          <div className="narrow">
            <p className="eyebrow section-eyebrow">Questions fréquentes</p>
            <h2 className="section-title reveal">
              Vous vous <em>demandez</em>…
            </h2>
            <div className="faq-list">
              <details className="faq-item reveal" open>
                <summary>
                  C&apos;est vraiment gratuit&nbsp;?{' '}
                  <span className="pm" aria-hidden="true">
                    +
                  </span>
                </summary>
                <div className="a">
                  <p>
                    Oui. Pas de commission sur les participations, pas d&apos;abonnement, pas de
                    frais cachés. Vos invités versent directement sur vos coordonnées (IBAN, Lydia,
                    Wero ou PayPal), nous ne touchons à rien.
                  </p>
                </div>
              </details>
              <details className="faq-item reveal">
                <summary>
                  Comment mes proches participent-ils&nbsp;?{' '}
                  <span className="pm" aria-hidden="true">
                    +
                  </span>
                </summary>
                <div className="a">
                  <p>
                    Au choix&nbsp;: en versant un montant libre pour un objet (la moitié, tout le
                    reste, ou un montant personnalisé), ou en s&apos;engageant à offrir l&apos;objet
                    entier en personne. Ils confirment ensuite avoir effectué le geste — la liste se
                    met à jour.
                  </p>
                </div>
              </details>
              <details className="faq-item reveal">
                <summary>
                  Ma page est-elle visible publiquement&nbsp;?{' '}
                  <span className="pm" aria-hidden="true">
                    +
                  </span>
                </summary>
                <div className="a">
                  <p>
                    Non. Chaque liste est accessible via un lien privé que vous partagez uniquement
                    aux personnes invitées. La page n&apos;est pas indexée par les moteurs de
                    recherche.
                  </p>
                </div>
              </details>
              <details className="faq-item reveal">
                <summary>
                  Puis-je modifier la liste après l&apos;avoir publiée&nbsp;?{' '}
                  <span className="pm" aria-hidden="true">
                    +
                  </span>
                </summary>
                <div className="a">
                  <p>
                    Bien sûr. Vous pouvez ajouter, modifier ou retirer un objet à tout moment — y
                    compris pendant que vos invités consultent la liste.
                  </p>
                </div>
              </details>
              <details className="faq-item reveal">
                <summary>
                  Et si on ne veut pas d&apos;objets, juste une cagnotte&nbsp;?{' '}
                  <span className="pm" aria-hidden="true">
                    +
                  </span>
                </summary>
                <div className="a">
                  <p>
                    C&apos;est possible — créez une seule &quot;envie&quot; générale (un voyage, une
                    chambre, des séances photo) et laissez la liberté à vos proches d&apos;y
                    contribuer.
                  </p>
                </div>
              </details>
              <details className="faq-item reveal">
                <summary>
                  Vous gardez nos coordonnées bancaires&nbsp;?{' '}
                  <span className="pm" aria-hidden="true">
                    +
                  </span>
                </summary>
                <div className="a">
                  <p>
                    Vos coordonnées de paiement (IBAN, etc.) sont stockées chiffrées et
                    n&apos;apparaissent que sur votre liste. Elles ne sont jamais partagées,
                    vendues, ni utilisées à d&apos;autres fins.
                  </p>
                </div>
              </details>
            </div>
          </div>
        </section>

        <section className="final" id="creer">
          <div className="narrow">
            <div className="hero-stripe" aria-hidden="true">
              <span>·</span>
              <span>·</span>
              <span>·</span>
            </div>
            <p className="eyebrow">Prêt·e&nbsp;?</p>
            <h2>
              Une liste, à votre <em>image</em>.
            </h2>
            <p>Quelques minutes suffisent. Vous pourrez l&apos;affiner à tout moment.</p>
            <div className="cta-row">
              <Link to="/me/new" className="btn-primary" id="ctaBottom">
                Créer ma liste{' '}
                <span className="arrow" aria-hidden="true">
                  →
                </span>
              </Link>
            </div>
            <p className="meta-line">Sans carte bancaire · Sans engagement · 100&nbsp;% gratuit</p>
            <div className="ornament" style={{ marginTop: 48 }}>
              <span className="dot" />
              <span className="line" />
              <span className="dot" />
            </div>
          </div>
        </section>

        <footer className="site-footer">
          <div className="wrap">
            <div>
              <p className="brand-foot">Liste de naissance</p>
              <p className="tagline">
                Une page douce et privée pour accueillir bébé, sans intermédiaire.
              </p>
            </div>
            <div>
              <h4>Le service</h4>
              <ul>
                <li>
                  <a href="#fonctionne">Comment ça marche</a>
                </li>
                <li>
                  <a href="#exemple">Voir un exemple</a>
                </li>
                <li>
                  <a href="#temoignages">Témoignages</a>
                </li>
                <li>
                  <a href="#faq">FAQ</a>
                </li>
              </ul>
            </div>
            <div>
              <h4>Aide</h4>
              <ul>
                <li>
                  <a href="mailto:hello@listedenaissance.app">Nous écrire</a>
                </li>
                <li>
                  <a href="/privacy">Confidentialité</a>
                </li>
                <li>
                  <a href="/terms">Conditions</a>
                </li>
              </ul>
            </div>
            <div>
              <h4>Compte</h4>
              <ul>
                <li>
                  <Link to="/auth/sign-in">Se connecter</Link>
                </li>
                <li>
                  <Link to="/me/new">Créer ma liste</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="wrap foot-bar">
            <span>© 2026 Liste de naissance</span>
            <span>Fait avec soin, à Paris.</span>
          </div>
        </footer>
      </main>
    </div>
  )
}
